module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Img"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "common-table-row-img"
        }, [_c('img', {
          attrs: {
            "src": scope.row.PfImg
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PfName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PfSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Problem Feedback Details",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('ProblemFeedBackForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Problem feedback management")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-51622f1a","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/other/ProblemFeedBack.vue
// module id = 766
// module chunks = 1